import { type FC } from 'react'

import { PrescriptionV3PrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import { useActivateZeroEuroCopaymentExperiment } from '../../../experiments/zero-euro-copayment-eligibility/useActivateZeroEuroCopaymentExperiment'
import { useZeroEuroCopaymentEligibility } from '../../../experiments/zero-euro-copayment-eligibility/ZeroEuroCopaymentEligibilityProvider'
import { useProductPageContext } from '../productPageContext'

import { ProductOverviewPrescriptionBonusCard } from './ProductOverviewPrescriptionBonusCard'
import { ProductOverviewPrescriptionZeroCopaymentCard } from './ProductOverviewPrescriptionZeroCopaymentCard/ProductOverviewPrescriptionZeroCopaymentCard'

type ProductOverviewPrescriptionBonusInfoBannerProps = {
  bonus: number
}

export const ProductOverviewPrescriptionBonusInfoBanner: FC<
  ProductOverviewPrescriptionBonusInfoBannerProps
> = ({ bonus }) => {
  const isZeroEuroCopaymentEligible = useZeroEuroCopaymentEligibility()
  const { currentPrescriptionType } = useProductPageContext()

  const isZeroCopaymentPrescription =
    currentPrescriptionType ===
      PrescriptionV3PrescriptionTypeEnum.InsurancePrescription &&
    isZeroEuroCopaymentEligible
  useActivateZeroEuroCopaymentExperiment(isZeroCopaymentPrescription)

  return isZeroCopaymentPrescription ? (
    <ProductOverviewPrescriptionZeroCopaymentCard />
  ) : (
    <ProductOverviewPrescriptionBonusCard bonus={bonus} />
  )
}
